import { APP_NAME } from 'src/constants/appConstants';
import ENVIRONMENT_VARIABLES from 'src/constants/environmentVariables';

export const getTitlePrefix = (): string => {
  const stage = ENVIRONMENT_VARIABLES.env.Stage;
  switch (stage) {
    case 'dev':
      return '[Local] ';
    case 'alpha':
      return '[Alpha] ';
    case 'beta':
      return '[Beta] ';
    case 'prod':
      return '';
    default:
      return '';
  }
};

export const getDocumentTitle = (): string => {
  const prefix = getTitlePrefix();
  return `${prefix}${APP_NAME}`;
};
